import {StrArr, StrMap} from "../../interfaces/common";

export interface SurveyQuestionInterface {
  id: string;
  name: string;
  translationsName: StrMap;
  focusAreaName: string;
  scoreSelf: number;
  scoreOther: number;
  scoreSelfNormalized: number;
  scoreOtherNormalized: number;
  gap: number;
  scoreList: Array<number>;
  spreadRespondentsNormalized: number;
  freeTexts: Array<string>;
  focusArea?: SurveyFocusArea;
}

export interface SurveySectionInterface {
  id: string;
  name: string;
  translationsName: StrMap;
  scoreSelf: number;
  scoreOther: number;
  gap: number;
  questions: Array<SurveyQuestionInterface>;
}

export interface LinkRequestInterface {
  id: string;
  date: string;
}

export enum FeedbackType {
  FEEDBACK = 0,
  ONLY_SELF = 1,
}

export interface SurveyFocusArea {
  id: string;
  name: string;
  translationsName: StrMap;
  health: number;
  healthLevel: number;
  scoreOther: number;
  scoreSelf: number;
  gap: number;
  spreadRespondentsNormalized: number;
  spreadQuestionsNormalized: number;
  questions: Array<SurveyQuestionInterface>;
}

export interface SurveyRespondent {
  name: string;
  email: string;
}

export interface SurveyResultInterface {
  categoryId: string;
  categoryName: string;
  categoryNameSv: string;
  scoreSelf: number;
  scoreOther: number;
  gap: number;
  spreadQuestions: number;
  spreadQuestionsNormalized: number;
  spreadRespondents: number;
  spreadRespondentsNormalized: number;
  respondents: Array<SurveyRespondent>;
  focusAreas: Array<SurveyFocusArea>;
  nrOtherResponses: number;
  nrAnswerOptions: number;
  answerOptions: StrArr;
  languages: Array<string>;
}

export interface AiFocusArea {
  id: string;
  insights: string;
  health: string;
  summary: string;
}

export interface AiInsights {
  summary: string;
  strengths: string;
  improvements: string;
  focusAreas: Array<AiFocusArea>;
}